const header = "sticky top-0 z-10 flex h-16 items-center justify-between border-b border-border/50 px-4 bg-background sm:px-6";

const leftSection = "flex items-center gap-3 min-w-0";

const menuBtn = "rounded-md p-2 text-muted-foreground hover:bg-accent hover:text-foreground lg:hidden";

const titleSection = "min-w-0";

const pageTitle = "text-lg font-semibold text-foreground truncate";

const breadcrumbRow = "hidden sm:flex items-center gap-1 text-xs text-muted-foreground";

const divider = "h-px w-px bg-border/50 mx-1";

const avatar = "h-8 w-8 rounded-full gradient-brand flex items-center justify-center text-xs font-semibold text-white shadow-md cursor-default";

const userEmail = "hidden text-sm text-muted-foreground sm:inline truncate max-w-[150px]";

const logoutBtn = "rounded-md p-2 text-muted-foreground hover:bg-accent hover:text-foreground transition-all duration-200 flex items-center gap-1.5";

const logoutText = "hidden sm:inline text-sm";

const truncate = "truncate";

export { header, leftSection, menuBtn, titleSection, pageTitle, breadcrumbRow, divider, avatar, userEmail, logoutBtn, logoutText, truncate };
